import { router } from '@/_helpers';
import i18n from '@/_helpers/i18n';

export const header = {
  namespaced: true,
  state: {
    tab: 'ALL',
    tabs:
    {
      "campaigns": [
        {
          referencia: "ALL",
          nombre: i18n.t("lang.label.all"),

        },
        {
          referencia: "SELECTED",
          nombre: i18n.t("lang.label.selected"),
        },
      ],
      "settings-account": [
        {
          referencia: "ACCOUNT",
          roles: [1, 3, 4, 6],
          nombre: i18n.t("lang.label.account"),

        },
        {
          referencia: "BLACKLIST",
          roles: [4, 3],
          nombre: "Blacklist",
        },
        {
          referencia: "EMAILSETTINGS",
          roles: [1,2],
          nombre: i18n.t("lang.label.emailsettings"),
        },
        // {
        //   referencia: "EMAILSETTINGS",
        //   roles: [3, 4],
        //   nombre: i18n.t("lang.label.calendarsettings"),
        // },
        {
          referencia: "BILLING",
          roles: [1, 2, 4],
          nombre: i18n.t("lang.label.billing"),
        },
        {
          referencia: "DOCUMENTS",
          roles: [1, 4],
          nombre: i18n.t("lang.label.documents"),
        },
        {
          referencia: "OLIVERSETTINGS",
          roles: [1],
          nombre: i18n.t("lang.label.settings"),
        },
        {
          referencia: "IA_PROMPS",
          roles: [1],
          nombre: "AI Agents Prompts",
        },
        {
          referencia: "CAMPAIGNSTEPTEMPLATE",
          roles: [1],
          nombre: i18n.t("lang.label.template"),
        },
        {
          referencia: "CUSTOMFIELDS",
          roles: [2],
          nombre: i18n.t("lang.mycontacts.gotocreatecustomfields"),
        },
        // {
        //   referencia: "TEAM",
        //   roles: [2,4],
        //   nombre: i18n.t("lang.label.team"),
        // },
        {
          referencia: "INTEGRATIONS",
          roles: [1, 2, 4],
          planIdAccess: [2, 3, 4, 5],
          nombre: i18n.t("lang.label.integrations"),
        },
        {
          referencia: "rgpd",
          roles: [1],
          nombre: "RGPD",
        },
        {
          referencia: "COLDCALLRULES",
          roles: [1],
          nombre: "Cold call rules",
        }
      ],
    },
  },
  actions: {
    changeTab({ commit }, args) {
      if(args.tab){
        commit('changeTab', args.tab);
      }
    }
  },
  mutations: {
    changeTab(state, tab) {
      state.tab = tab
    },
  }
}
